<template>
  <div>
    <div id="chart"></div>
  </div>
</template>

<script>
export default {
  mounted() {
    var options = {
      chart: {
        //https://apexcharts.com/docs/chart-types/
        //type: "area"
        //type: "line"
        //type: "bar"
        //type: "donut"
        type: "pie"
      },
      // for donut //labels: ["Apple", "Mango", "Orange", "Watermelon"],
      series: [30, 40, 35, 50, 49, 60, 70, 91, 125],
      chartOptions: {
        labels: ["Apple", "Mango", "Orange", "Watermelon"]
      },
      series_area: [
        {
          name: "sales",
          data: [30, 40, 35, 50, 49, 60, 70, 91, 125]
        }
      ],
      //   series: [
      //     {
      //       data: [
      //         {
      //           x: "category A",
      //           y: 10
      //         },
      //         {
      //           x: "category B",
      //           y: 18
      //         },
      //         {
      //           x: "category C",
      //           y: 13
      //         }
      //       ]
      //     }
      //   ],
      xaxis: {
        categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998, 1999]
      }
    };

    var chart = new ApexCharts(document.querySelector("#chart"), options);

    chart.render();
  }
};
</script>

<style lang="scss" scoped></style>
